import * as React from 'react';
import {NonLoggedBG} from "../../../default/components/NonLoggedBG/LiveNonLoggedBG";
const s = require('./MetropolisNonLoggedBG.scss') as {
  root:string;
};

export class MetropolisNonLoggedBG extends NonLoggedBG {
  render() {
    return (
      <div className={s.root + ' ' + this.props.className}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/themes/metropolis/components/NonLoggedBG/MetropolisNonLoggedBG.tsx